<template>
    <q-page :padding="true" :class="{ row: centered, 'justify-center': centered, 'items-center': centered }">
        <slot></slot>
    </q-page>
</template>

<script>
    import {QPage} from 'quasar-framework'

    export default {
        name: 'Page',

        props: {
            padding: {
                type: Boolean,
                default: true
            },
            centered: {
                type: Boolean,
                default: true
            }
        },

        components: {
            QPage
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Page.vue